import { Check } from "lucide-react";
import { Input } from "../ui/input";

// Grote, toetsenbord-bedienbare keuzetegels. Bij multi wordt een lijst met id's bijgehouden.
export const Choice = ({ name, label, hint, options, value, onChange, cols = "grid-cols-1 sm:grid-cols-3", multi = false }) => (
  <fieldset className="min-w-0">
    {label && <legend className="mb-2.5 text-[15px] font-semibold leading-snug text-ink">{label}</legend>}
    {hint && <p className="-mt-1 mb-3 text-[13.5px] leading-relaxed text-slate-500">{hint}</p>}
    <div className={`grid gap-2.5 ${cols}`} role={multi ? "group" : "radiogroup"} aria-label={label}>
      {options.map((o) => {
        const on = multi ? value.includes(o.id) : value === o.id;
        return (
          <button key={o.id} type="button" role={multi ? "checkbox" : "radio"} aria-checked={on} onClick={() => onChange(o.id)}
            data-testid={`isde-${name}-${o.id.replace(/[^a-zA-Z0-9]+/g, "-").toLowerCase()}`}
            className={`flex min-h-[52px] items-center justify-between gap-3 rounded-xl border px-4 py-3 text-left text-[14.5px] transition-[border-color,background-color,box-shadow] duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-maas/40 ${
              on ? "border-maas bg-maas-soft font-semibold text-maas-deep shadow-[0_0_0_1px_theme(colors.maas.DEFAULT)]" : "border-slate-200 bg-white text-ink hover:border-slate-300 hover:bg-slate-50"}`}>
            <span>{o.label}</span>
            <span className={`flex h-5 w-5 shrink-0 items-center justify-center ${multi ? "rounded-md" : "rounded-full"} ${on ? "bg-maas text-white" : "ring-1 ring-slate-300"}`}>
              {on && <Check className="h-3.5 w-3.5" aria-hidden="true" />}
            </span>
          </button>
        );
      })}
    </div>
  </fieldset>
);

export const NumberField = ({ id, label, hint, value, onChange, suffix, placeholder, max = 6 }) => (
  <div>
    <label htmlFor={id} className="block text-[15px] font-semibold text-ink">{label}</label>
    {hint && <p className="mt-0.5 text-[13.5px] text-slate-500">{hint}</p>}
    <div className="relative mt-2 max-w-[220px]">
      <Input id={id} inputMode="decimal" value={value} maxLength={max} placeholder={placeholder} data-testid={`isde-${id}`}
        onChange={(e) => onChange(e.target.value.replace(/[^0-9.,]/g, ""))} className="h-12 rounded-xl border-slate-300 pr-14 text-[15px]" />
      {suffix && <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-[14px] text-slate-500">{suffix}</span>}
    </div>
  </div>
);

export const InfoNote = ({ children, testid }) => (
  <p className="rounded-xl border border-maas/20 bg-maas-soft/60 px-4 py-3 text-[13.5px] leading-relaxed text-maas-deep" data-testid={testid}>{children}</p>
);
